import { IPageTabNavLink } from "../interfaces-and-types";

export const externalaccountLink: IPageTabNavLink[] = [
    {
        name: 'Linked external account',
        route: '',
    },
]